import createAction from '../services/create-action';

export const NEW_COMMENT = 'comment/NEW';
export const SOCKET_NEW_COMMENT = 'new comment';

export const newComment = createAction(NEW_COMMENT);



// WEBPACK FOOTER //
// ./app/actions/comment-socket.js